var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChainCoordination(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.33364,
    y: -0.333644,
    width: 14.086,
    height: 14.0005
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.17px)",
      clipPath: "url(#bgblur_0_9308_7462_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 2.33364,
    d: "M5.70932 2C3.10978 2 1 4.09114 1 6.66668C1 9.24316 3.10978 11.3334 5.70932 11.3334C8.31358 11.3334 10.4186 9.24316 10.4186 6.66668C10.4186 4.09114 8.31358 2 5.70932 2Z",
    fill: "url(#paint0_linear_9308_7462)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_9308_7462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70943 4.38745C4.43956 4.38745 3.40894 5.40897 3.40894 6.66712C3.40894 7.92572 4.43956 8.94678 5.70943 8.94678C6.98161 8.94678 8.00993 7.92572 8.00993 6.66712C8.00993 5.40897 6.98161 4.38745 5.70943 4.38745Z",
    fill: "#FF3D22"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.17436,
    y: 2.58468,
    width: 20.0467,
    height: 16.2874
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.35px)",
      clipPath: "url(#bgblur_1_9308_7462_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.69267
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_9308_7462",
    maskUnits: "userSpaceOnUse",
    x: 0.697754,
    y: 4.45679,
    width: 16,
    height: 12,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.697754,
    y: 4.45679,
    width: 16,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9583 10.5367C15.2118 8.94564 14.1722 7.67406 12.9513 6.80504C11.7304 5.92964 10.328 5.45679 8.84895 5.45679H8.84197C5.8908 5.45679 3.23264 7.35457 1.73961 10.5367C1.6838 10.6581 1.6838 10.7987 1.73961 10.9137C3.23264 14.0959 5.8908 16 8.84197 16H8.84895C11.8071 16 14.4653 14.0959 15.9583 10.9137C16.0141 10.7987 16.0141 10.6581 15.9583 10.5367Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9583 10.5367C15.2118 8.94564 14.1722 7.67406 12.9513 6.80504C11.7304 5.92964 10.328 5.45679 8.84895 5.45679H8.84197C5.8908 5.45679 3.23264 7.35457 1.73961 10.5367C1.6838 10.6581 1.6838 10.7987 1.73961 10.9137C3.23264 14.0959 5.8908 16 8.84197 16H8.84895C11.8071 16 14.4653 14.0959 15.9583 10.9137C16.0141 10.7987 16.0141 10.6581 15.9583 10.5367Z",
    fill: "#FF5563",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7958 10.613C15.8379 10.7027 15.9448 10.7413 16.0345 10.6992C16.1243 10.6571 16.1629 10.5502 16.1208 10.4605L15.7958 10.613ZM12.9513 6.80504L12.8467 6.95093L12.8472 6.95129L12.9513 6.80504ZM1.73961 10.5367L1.5771 10.4605L1.57651 10.4617L1.73961 10.5367ZM1.73961 10.9137L1.90214 10.8375L1.90111 10.8353L1.73961 10.9137ZM15.9583 10.9137L15.7968 10.8353L15.7958 10.8375L15.9583 10.9137ZM16.1214 10.4617C16.08 10.3717 15.9734 10.3322 15.8833 10.3736C15.7932 10.415 15.7538 10.5216 15.7952 10.6117L16.1214 10.4617ZM15.9583 10.5367L16.1208 10.4605C15.3628 8.84497 14.3045 7.54788 13.0554 6.6588L12.9513 6.80504L12.8472 6.95129C14.04 7.80025 15.0607 9.04632 15.7958 10.613L15.9583 10.5367ZM12.9513 6.80504L13.0559 6.65916C11.8062 5.76314 10.3677 5.27728 8.84895 5.27728V5.45679V5.6363C10.2884 5.6363 11.6545 6.09613 12.8467 6.95093L12.9513 6.80504ZM8.84895 5.45679V5.27728H8.84197V5.45679V5.6363H8.84895V5.45679ZM8.84197 5.45679V5.27728C5.80638 5.27728 3.09284 7.22992 1.5771 10.4605L1.73961 10.5367L1.90213 10.613C3.37245 7.47923 5.97522 5.6363 8.84197 5.6363V5.45679ZM1.73961 10.5367L1.57651 10.4617C1.49944 10.6294 1.49767 10.8263 1.57811 10.9921L1.73961 10.9137L1.90111 10.8353C1.86993 10.7711 1.86816 10.6869 1.90272 10.6117L1.73961 10.5367ZM1.73961 10.9137L1.5771 10.99C3.09273 14.2203 5.80615 16.1795 8.84197 16.1795V16V15.8205C5.97544 15.8205 3.37256 13.9714 1.90213 10.8375L1.73961 10.9137ZM8.84197 16V16.1795H8.84895V16V15.8205H8.84197V16ZM8.84895 16V16.1795C11.8917 16.1795 14.6051 14.2204 16.1208 10.99L15.9583 10.9137L15.7958 10.8375C14.3254 13.9714 11.7225 15.8205 8.84895 15.8205V16ZM15.9583 10.9137L16.1198 10.9921C16.2002 10.8263 16.1985 10.6294 16.1214 10.4617L15.9583 10.5367L15.7952 10.6117C15.8297 10.6869 15.828 10.7711 15.7968 10.8353L15.9583 10.9137Z",
    fill: "url(#paint1_linear_9308_7462)",
    mask: "url(#path-3-outside-1_9308_7462)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 4.06344,
    y: 6.04806,
    width: 9.57137,
    height: 9.53352
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.35px)",
      clipPath: "url(#bgblur_2_9308_7462_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_9308_7462)",
    "data-figma-bg-blur-radius": 2.69267
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9422 10.819C10.9422 11.9578 10.0026 12.8889 8.85333 12.8889C7.69566 12.8889 6.7561 11.9578 6.7561 10.819C6.7561 10.6776 6.77288 10.5446 6.79805 10.4116H6.83999C7.77116 10.4116 8.52616 9.68009 8.55972 8.76566C8.652 8.74904 8.75266 8.74072 8.85333 8.74072C10.0026 8.74072 10.9422 9.67177 10.9422 10.819Z",
    fill: "url(#paint2_linear_9308_7462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85376 8.7583C9.993 8.75853 10.924 9.68188 10.9241 10.8188C10.9241 11.9475 9.99309 12.8704 8.85376 12.8706C7.7058 12.8706 6.77368 11.9476 6.77368 10.8188C6.77369 10.684 6.79018 10.5567 6.81372 10.4292H6.84009C7.77555 10.4291 8.53363 9.69859 8.57544 8.78174C8.66314 8.76677 8.75856 8.7583 8.85376 8.7583Z",
    stroke: "url(#paint3_linear_9308_7462)",
    strokeOpacity: 0.5,
    strokeWidth: 0.0359022
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7462_clip_path",
    transform: "translate(1.33364 0.333644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70932 2C3.10978 2 1 4.09114 1 6.66668C1 9.24316 3.10978 11.3334 5.70932 11.3334C8.31358 11.3334 10.4186 9.24316 10.4186 6.66668C10.4186 4.09114 8.31358 2 5.70932 2Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9308_7462",
    x: -0.181285,
    y: 0.797231,
    width: 11.7815,
    height: 11.7398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79511,
    result: "effect1_foregroundBlur_9308_7462"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7462_clip_path",
    transform: "translate(1.17436 -2.58468)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9583 10.5367C15.2118 8.94564 14.1722 7.67406 12.9513 6.80504C11.7304 5.92964 10.328 5.45679 8.84895 5.45679H8.84197C5.8908 5.45679 3.23264 7.35457 1.73961 10.5367C1.6838 10.6581 1.6838 10.7987 1.73961 10.9137C3.23264 14.0959 5.8908 16 8.84197 16H8.84895C11.8071 16 14.4653 14.0959 15.9583 10.9137C16.0141 10.7987 16.0141 10.6581 15.9583 10.5367Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9308_7462",
    x: 4.06344,
    y: 6.04806,
    width: 9.57137,
    height: 9.53352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.897555,
    dy: 0.897555
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.897555
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.447059 0 0 0 0 0.368627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7462"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7462",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_9308_7462_clip_path",
    transform: "translate(-4.06344 -6.04806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9422 10.819C10.9422 11.9578 10.0026 12.8889 8.85333 12.8889C7.69566 12.8889 6.7561 11.9578 6.7561 10.819C6.7561 10.6776 6.77288 10.5446 6.79805 10.4116H6.83999C7.77116 10.4116 8.52616 9.68009 8.55972 8.76566C8.652 8.74904 8.75266 8.74072 8.85333 8.74072C10.0026 8.74072 10.9422 9.67177 10.9422 10.819Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7462",
    x1: 9.0731,
    y1: 3,
    x2: -0.18901,
    y2: 9.23426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7462",
    x1: 3.97446,
    y1: 6.68509,
    x2: 10.0219,
    y2: 16.8455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7462",
    x1: 10.6454,
    y1: 9.4898,
    x2: 5.98259,
    y2: 9.64321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7462",
    x1: 10.7628,
    y1: 10.9025,
    x2: 6.69316,
    y2: 11.0736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainCoordination);
export default __webpack_public_path__ + "static/media/chainCoordination.f2c75d9163fb056c9e34d8a12f1ad24d.svg";
export { ForwardRef as ReactComponent };